export const LOGO_URL = "/aura-logo.png";

export const DOMAIN = "auraplusgear.com";

export const AMAZON_URL =
  "https://www.amazon.it/AURA-Custodia-rigida-Meta-Quest/dp/B0GNTBZRJJ";

export const STATUS_META = {
  pending: { label: "In attesa", color: "text-zinc-300", dot: "bg-zinc-400", ring: "border-zinc-700" },
  approved: { label: "Approvato", color: "text-sky-300", dot: "bg-sky-400", ring: "border-sky-500/40" },
  shipped: { label: "Prodotto spedito", color: "text-amber-300", dot: "bg-amber-400", ring: "border-amber-500/40" },
  delivered: { label: "Consegnato", color: "text-violet-300", dot: "bg-violet-400", ring: "border-violet-500/40" },
  content_published: { label: "Contenuto pubblicato", color: "text-cyan-300", dot: "bg-cyan-400", ring: "border-cyan-500/40" },
  active: { label: "Creator attivo", color: "text-emerald-300", dot: "bg-emerald-400", ring: "border-emerald-500/40" },
  inactive: { label: "Creator inattivo", color: "text-zinc-500", dot: "bg-zinc-600", ring: "border-zinc-800" },
};

export const STATUS_ORDER = [
  "pending", "approved", "shipped", "delivered", "content_published", "active", "inactive",
];

export const TIER_ORDER = ["explorer", "creator", "ambassador"];

// Orders needed to reach each tier (used for the progress bar on the creator dashboard)
export const TIER_THRESHOLDS = { explorer: 0, creator: 3, ambassador: 10 };

export const CRM_STAGES = ["to_contact", "contacted", "responded", "deal", "shipped", "published", "done", "not_interested"];
export const CRM_PLATFORMS = ["instagram", "tiktok", "youtube", "other"];
export const CRM_CONTACT_TYPES = ["creator", "customer", "store"];

export const EU_COUNTRIES = [
  "Austria", "Belgio", "Bulgaria", "Cipro", "Croazia", "Danimarca", "Estonia", "Finlandia",
  "Francia", "Germania", "Grecia", "Irlanda", "Italia", "Lettonia", "Lituania", "Lussemburgo",
  "Malta", "Paesi Bassi", "Polonia", "Portogallo", "Repubblica Ceca", "Romania", "Slovacchia",
  "Slovenia", "Spagna", "Svezia", "Ungheria",
];

export const NON_EU_COUNTRIES = [
  "Regno Unito", "Svizzera", "Norvegia", "Islanda", "Stati Uniti", "Canada", "Australia",
  "Emirati Arabi Uniti", "Giappone", "Brasile", "Altro (Extra-UE)",
];

export const COUNTRY_OPTIONS = [...EU_COUNTRIES, ...NON_EU_COUNTRIES];

export const isEU = (country) => EU_COUNTRIES.includes((country || "").trim());

export const TIER_META = {
  explorer: { idx: 0, color: "text-zinc-200", ring: "border-zinc-600", dot: "bg-zinc-400" },
  creator: { idx: 1, color: "text-sky-300", ring: "border-sky-500/40", dot: "bg-sky-400" },
  ambassador: { idx: 2, color: "text-amber-300", ring: "border-amber-500/40", dot: "bg-amber-400" },
};

export const PRODUCT_IMG =
  "https://images.unsplash.com/photo-1780547292624-8bc828bdae07?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHwzfHxNZXRhJTIwUXVlc3QlMjAzJTIwVlIlMjBoZWFkc2V0JTIwZGFyayUyMHByZW1pdW18ZW58MHx8fHwxNzgzOTUxOTgxfDA&ixlib=rb-4.1.0&q=85";

export const HERO_IMG =
  "https://images.unsplash.com/photo-1759338245039-906f7558e743?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzR8MHwxfHNlYXJjaHw0fHx2aXJ0dWFsJTIwcmVhbGl0eSUyMGhlYWRzZXQlMjBkYXJrJTIwbWluaW1hbHxlbnwwfHx8fDE3ODM5NTE4NTV8MA&ixlib=rb-4.1.0&q=85";

export const STUDIO_IMG =
  "https://images.unsplash.com/photo-1768818653161-0ad28dede131?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwzfHxjb250ZW50JTIwY3JlYXRvciUyMGZpbG1pbmclMjBzdHVkaW8lMjBkYXJrJTIwbW9vZHl8ZW58MHx8fHwxNzgzOTUxOTgxfDA&ixlib=rb-4.1.0&q=85";
